import { render, staticRenderFns } from "./PageEditPartDescription.vue?vue&type=template&id=22c93f0b&"
import script from "./PageEditPartDescription.vue?vue&type=script&lang=js&"
export * from "./PageEditPartDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports